import { RouterProvider } from '@tanstack/react-router';
import { type JSX, StrictMode } from 'react';
import { ErrorReportingComponent } from 'ts/base/components/ErrorReportingComponent';
import { DebuggingPanel } from 'ts/base/perspective/debugger/DebuggingPanel';
// Initialize the profiler store early to capture service calls from initial page load
import 'ts/base/perspective/debugger/UiDebugger.store';
import { BaseProviders } from 'ts/base/ReactUtils';
import { ROUTER } from 'ts/base/routing/Router';
import { ModalManager } from 'ts/commons/modal/ModalManager';
import { Notifications } from 'ts/components/Toast';

/** Top level router that instantiates the perspective named in the current browser url. */
export function App(): JSX.Element {
	return (
		<StrictMode>
			<BaseProviders>
				<Notifications position="bottom-right" limit={5} />
				<ModalManager />
				<ErrorReportingComponent>
					<RouterProvider router={ROUTER} />
					<DebuggingPanel />
				</ErrorReportingComponent>
			</BaseProviders>
		</StrictMode>
	);
}
